import React, { Component } from "react";
import { Link } from "react-router-dom";
import Image from "../../../base/features/micro/Image";
import checkLength from "../../../base/utils/check_length";

class OtherShops extends Component {
  render() {
    return (
      <div className="row mx-0">
        <h2 className="fw-bold fs-5 px-4 py-3 mt-2 mb-0">سایر فروشگاه ها</h2>
        <div
          className="p-0 scrollbar-hide"
          style={{
            overflow: "scroll hidden",
            whiteSpace: "nowrap",
          }}
        >
          <div className="px-4 py-3">
            {this.props.shops.map((shop, s) => (
              <div
                className="align-top d-inline-block ms-3 text-center"
                style={{ width: "90px" }}
              >
                <Link to={`/${shop.uid}`}>
                  <Image
                    imageHeight={"90"}
                    imageWidth={"90"}
                    extraClassName={"rounded14 p-2 bg-color-main"}
                    imgClassName={"rounded14 img-cover"}
                    imageUri={shop.cover && shop.cover.thumbnail}
                  />
                  <p className="mt-2 fw" style={{ whiteSpace: "break-spaces" }}>
                    {checkLength(shop.title, 30)}
                  </p>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default OtherShops;
